import { DOWNLOAD_REPORT } from '../../../constants';

const initialState = {
  data: {},
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case DOWNLOAD_REPORT.LOAD:
      return {
        ...state,
        loading: true,
      };
    case DOWNLOAD_REPORT.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case DOWNLOAD_REPORT.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
